import React from 'react'

export default props => (
    <tr {...props}>
		{props.children}
	</tr>
)
